<template>
    <main>
        <div class="input-select-box" v-click-outside="hideOption">
            <div class="select-value" @click="toggleOption">
                <i class="v" v-if="value">{{isObject(value) ? value.title : value}}</i>
                <i class="v" v-else>请选择</i>
                <i class="icon" :class="[show_option ? 'active' : '']"></i></div>
            <div class="select-options" v-show="show_option">
                <div class="item" :class="[value == '' ? 'active' : '']" @click="setValue('')">请选择</div>
                <div class="item" :class="[value == item ? 'active' : '']" v-for="item in option" @click="setValue(item)">{{isObject(item) ? item.title : item}}</div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'dell-select',
        data() {
            return {
                show_option:false,
                show_value:"",
            }
        },
        components:{

        },
        props:{
            option:{
                type:Array,
                default:[]
            },
            value:{
                type:Array | Object | String,
                default:''
            }
        },
        computed:{

        },
        methods: {
            isObject(obj){
                return Object.prototype.toString.call(obj) === '[object Object]'
            },
            setValue(item = ""){
                this.hideOption();
                this.$emit('setValue',item)
            },
            toggleOption(){
                this.show_option = !this.show_option;
            },
            showOption(){
                this.show_option = true;
            },
            hideOption(){
                this.show_option = false;
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .input-select-box{height:40px;line-height: 40px;background:#fafafa;border-radius:5px;border: 1px solid #f1f1f1;font-size: 14px;position: relative;
        .select-value{width: 100%;height:100%;overflow: hidden;display: flex;
            .v{margin-left: 15px;flex: 1; }
            .icon{float: right;width:40px;height:40px;background: url("~@/assets/image/61.png") no-repeat center center;background-size: 14px;transition: all .3s ease;}
            .icon.active{transform: rotate(180deg);transition: all .3s ease;}
        }
        .select-options{position: absolute;left:-1px;top:100%;width: 100%;max-height:400px;overflow: hidden;overflow-y: auto;z-index: 99;background: #fff;border: 1px solid #f1f1f1; padding-bottom: 10px;
            .item{height:40px;line-height: 40px;padding: 0 14px;overflow: hidden}
            .item:hover,.item.active{background: #fafafa;}
        }
    }
</style>

